import { render, staticRenderFns } from "./ModalConsultATM.vue?vue&type=template&id=5b5511d0"
import script from "./ModalConsultATM.vue?vue&type=script&lang=js"
export * from "./ModalConsultATM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports